import $ from 'cash-dom';
function detectEdge() {
  const ua = window.navigator.userAgent;
  const edge = ua.indexOf('Edge/');
  if (edge > 0) {
    return parseInt(ua.substring(edge + 5, ua.indexOf('.', edge)), 10);
  }
  return false;
}
export default function () {
  if (detectEdge()) {
    const sparklines = $('.card__chart > img');
    $(sparklines).css('display', 'none');
    for (const image of sparklines) {
      const canvasEl = $('<canvas></canvas>').appendTo($(image).parent());
      const canvas = $(canvasEl)[0];
      const ctx = canvas.getContext('2d');
      const img = new Image();
      img.onload = function () {
        canvas.height = canvas.width * (img.height / img.width);
        const oc = document.createElement('canvas');
        const octx = oc.getContext('2d');
        oc.width = img.width * 0.5;
        oc.height = img.height * 0.5;
        octx.drawImage(img, 0, 0, oc.width, oc.height);
        octx.drawImage(oc, 0, 0, oc.width * 0.5, oc.height * 0.5);
        ctx.drawImage(oc, 0, 0, oc.width * 0.5, oc.height * 0.5, 0, 0, canvas.width, canvas.height);
      };
      img.src = `${location.origin}${$(image).attr('data-src')}`;
      $(canvasEl).css('width', '100%');
    }
  }
}